import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { usePrompt } from '@hooks'
import { AutocompleteOption } from '@types'
import { SearchFilterForm } from '../AddSimpleFilterDialog'
import { getDefaultValues } from '../helpers/getDefaultValues'
import { useInputs } from './useInputs'

type UseAddSimpleFilterDialogParams = {
  initialData?: Partial<SearchFilterForm>
  objectOptions: AutocompleteOption[]
  onSave: (filter: SearchFilterForm) => void
  onClose: () => void
  open?: boolean
}

export const useAddSimpleFilterDialog = ({
  initialData,
  objectOptions,
  onSave,
  onClose,
  open,
}: UseAddSimpleFilterDialogParams) => {
  const defaultValues = getDefaultValues()
  const methods = useForm<SearchFilterForm>({ defaultValues })
  const {
    handleSubmit,
    reset,
    formState: { isDirty },
  } = methods

  usePrompt({ when: isDirty })

  useEffect(() => {
    if (open) {
      if (initialData) {
        reset({
          ...defaultValues,
          ...initialData,
          value: {
            ...defaultValues.value,
            ...(initialData.value || {}),
          },
        })
      } else {
        reset(defaultValues)
      }
    }
  }, [initialData, open, reset])

  const handleSave = handleSubmit((data: SearchFilterForm) => {
    onSave(data)
    reset(defaultValues)
    onClose()
  })

  const searchFilterInputs = useInputs({
    objectOptions,
    isEdit: Boolean(initialData?.id),
    currentCode: initialData?.code,
  })

  return {
    isDirty,
    handleSave,
    methods,
    searchFilterInputs,
  }
}
